import { Component, HostBinding, Inject, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatIcon,
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
    TranslatePipe,
  ],
})
export class SnackBarComponent {
  public type: keyof typeof icons;
  public icon: string;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { message: string; action: string; type: keyof typeof icons }
  ) {
    this.icon = icons[data.type];
    this.type = data.type;
  }

  @HostBinding('class') public get class() {
    return `type-${this.type}`;
  }

  snackBarRef = inject(MatSnackBarRef);
}

const icons = {
  success: 'check_circle',
  error: 'error',
  warning: 'warning',
  info: 'info',
  update: 'refresh',
} as const;

export type Icons = typeof icons;
